// extracted by mini-css-extract-plugin
export var hidden = "_4k-1";
export var leftPanel = "_4k-2";
export var readonlyInspector = "_4k-3";
export var rightPanel = "_4k-0";